import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-indigo-900/20 border-y border-indigo-500/20 relative overflow-hidden" data-id="element-129">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-indigo-500/10 via-transparent to-transparent pointer-events-none" data-id="element-130" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-132">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-indigo-300" data-id="element-133">
            In just 7 days, most users report:
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-16 mb-12" data-id="element-134">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1,
          duration: 0.5
        }} className="text-center" data-id="element-135">
            <div className="font-heading text-7xl md:text-8xl font-bold text-white mb-4 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-136">
              40<span className="text-amber-500" data-id="element-137">%</span>
            </div>
            <p className="text-xl text-slate-300 font-medium" data-id="element-138">
              reduction in late-night screen time
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="text-center" data-id="element-139">
            <div className="font-heading text-7xl md:text-8xl font-bold text-white mb-4 drop-shadow-[0_0_15px_rgba(255,255,255,0.2)]" data-id="element-140">
              90
              <span className="text-indigo-400 text-5xl md:text-6xl ml-2" data-id="element-141">
                min
              </span>
            </div>
            <p className="text-xl text-slate-300 font-medium" data-id="element-142">
              extra of deep, restorative sleep
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center" data-id="element-143">
          <p className="inline-block bg-navy-900/80 border border-indigo-500/30 px-6 py-3 rounded-full text-lg md:text-xl text-white font-heading shadow-lg" data-id="element-144">
            The result:{' '}
            <span className="text-amber-400 font-semibold" data-id="element-145">
              waking up calm, clear, and in control.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}